export class AccordionToggleEvent extends CustomEvent {
    static name = 'mb-accordion-toggle';

    /** @type {HTMLElement} */
    item = undefined;

    /** @type {boolean} */
    open = undefined;

    /**
     * @param {HTMLElement} item
     * @param {boolean} open
     */
    constructor(item, open) {
        super(AccordionToggleEvent.name, { bubbles: true, cancelable: true, composed: true });
        this.item = item;
        this.open = open;
    }
}
